const hamburger = () => {
  const btn = document.querySelector('.header__hamburger');
  const closeBtn = document.querySelector('.hamburger__close');
  const nav = document.getElementById('hamburger');
  const html = document.documentElement;
  const body = document.body;
  let scrollY = 0;
  let currentAnim = null;

  const animTiming = {
    duration: 200,
    easing: 'ease-in-out',
    fill: 'forwards',
  };

  const cancelAnim = () => {
    if (currentAnim) {
      currentAnim.cancel();
      currentAnim = null;
    }
  };

  const resetScrollLock = () => {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.style.paddingRight = '';
    html.classList.remove('is-nav-open');
  };

  const lockScroll = () => {
    scrollY = window.scrollY;
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
    html.classList.add('is-nav-open');
  };

  const getTargetScrollTop = (target) => {
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    return target.getBoundingClientRect().top + scrollY - headerHeight;
  };

  const unlockScroll = ({ targetTop } = {}) => {
    resetScrollLock();

    if (targetTop != null) {
      // fixed 解除直後に先頭へ飛ぶのを防ぎ、開く前の位置を即時復元してから遷移先へスクロール
      window.scrollTo(0, scrollY);
      requestAnimationFrame(() => {
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      });
    } else {
      window.scrollTo(0, scrollY);
    }
  };

  if (btn && closeBtn && nav) {
    const open = () => {
      cancelAnim();
      btn.setAttribute('aria-expanded', 'true');
      nav.hidden = false;
      lockScroll();
      currentAnim = nav.animate([{ opacity: 0 }, { opacity: 1 }], animTiming);
      currentAnim.onfinish = () => {
        currentAnim = null;
        nav.classList.add('is-open');
      };
    };

    const close = ({ scrollTarget } = {}) => {
      if (nav.hidden) return;

      const targetTop = scrollTarget ? getTargetScrollTop(scrollTarget) : null;

      cancelAnim();
      btn.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');

      // アンカー遷移は close アニメーションと同時にスクロール開始
      if (targetTop != null) {
        unlockScroll({ targetTop });
      }

      currentAnim = nav.animate([{ opacity: 1 }, { opacity: 0 }], animTiming);
      currentAnim.onfinish = () => {
        currentAnim = null;
        nav.hidden = true;
        nav.style.opacity = '';
        if (targetTop == null) {
          unlockScroll();
        }
      };
    };

    const toggle = () =>
      btn.getAttribute('aria-expanded') === 'true' ? close() : open();

    btn.addEventListener('click', toggle);
    closeBtn.addEventListener('click', close);

    // Esc で閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    // メニュー内のリンクをクリックしたら閉じる
    nav.addEventListener('click', (e) => {
      const link = e.target.closest('.hamburger__link');
      if (!link) return;

      e.preventDefault();

      const href = link.getAttribute('href');
      let scrollTarget = null;
      if (href && href.startsWith('#') && href !== '#') {
        scrollTarget = document.querySelector(href);
      }

      close({ scrollTarget });
    });

    // ビューポート変更時はメニューを閉じた状態にリセット
    const mql = window.matchMedia('(min-width: 1024px)');
    const handleMQ = () => {
      cancelAnim();
      const wasOpen = html.classList.contains('is-nav-open');
      btn.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      nav.style.opacity = '';
      nav.hidden = true;

      if (wasOpen) {
        unlockScroll();
      } else {
        resetScrollLock();
      }
    };
    handleMQ();
    mql.addEventListener('change', handleMQ);
  }
};

export default hamburger();
